import { Box } from '@chakra-ui/react'
import EventTable from './components/EventTable'

export default function User () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <EventTable />
    </Box>
  )
}
